import { useState, useEffect } from 'react';

export default function AdModal({ isOpen, onClose, adType = 'endgame' }) {
  const [countdown, setCountdown] = useState(5);
  const [canSkip, setCanSkip] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setCountdown(5);
      setCanSkip(false);
      return;
    }

    // Load AdSense ads
    try {
      if (window.adsbygoogle && window.adsbygoogle.loaded !== true) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (err) {
      console.error('AdSense error:', err);
    }

    // Countdown timer for skip button
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          setCanSkip(true);
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isOpen]);

  if (!isOpen) return null;

  const adMessage = adType === 'midgame' 
    ? 'Intelligence Briefing - Turn 20 Strategic Update'
    : 'Post-Mission Intelligence Briefing';

  return (
    <div className="fixed inset-0 bg-black/90 backdrop-blur-md flex items-center justify-center z-50">
      <div className="bg-gradient-to-b from-slate-900 to-slate-950 border-4 border-yellow-500 rounded-lg max-w-4xl w-full mx-4 p-8 shadow-2xl"
        style={{
          boxShadow: '0 0 60px rgba(234, 179, 8, 0.5), inset 0 0 40px rgba(0, 0, 0, 0.8)'
        }}
      >
        {/* Header */}
        <div className="text-center mb-6">
          <div className="text-5xl mb-3">☢️ 📡 ☢️</div>
          <h2 className="text-3xl font-bold text-yellow-400 mb-2" style={{ textShadow: '0 0 20px rgba(234, 179, 8, 0.8)' }}>
            {adMessage}
          </h2>
          <p className="text-slate-400 text-sm">
            Supporting global thermonuclear strategy development...
          </p>
        </div>

        {/* Ad Container */}
        <div className="bg-slate-800/50 border-2 border-yellow-500/30 rounded-lg p-6 mb-6 min-h-[400px] flex items-center justify-center">
          {/* Google AdSense - Video Ad Unit */}
          <div className="w-full max-w-3xl">
            <ins
              className="adsbygoogle"
              style={{ display: 'block' }}
              data-ad-client="ca-pub-8461941127569704"
              data-ad-slot="auto"
              data-ad-format="auto"
              data-full-width-responsive="true"
            ></ins>
          </div>
        </div>

        {/* Video Ad Placeholder (AdSense will auto-detect and show video if available) */}
        <div className="text-center mb-4">
          <p className="text-slate-300 text-sm">
            🎬 <strong className="text-yellow-400">Video Intelligence Report</strong> in progress...
          </p>
        </div>

        {/* Skip Button */}
        <div className="text-center">
          {!canSkip ? (
            <button
              disabled
              className="px-8 py-4 bg-slate-700 text-slate-500 rounded-lg font-bold text-lg cursor-not-allowed"
            >
              Return to Command Center in {countdown}...
            </button>
          ) : (
            <button
              onClick={onClose}
              className="px-8 py-4 bg-gradient-to-r from-yellow-600 to-yellow-700 hover:from-yellow-700 hover:to-yellow-800 text-white rounded-lg font-bold text-lg transition-all border-2 border-yellow-400 shadow-lg"
              style={{
                boxShadow: '0 0 20px rgba(234, 179, 8, 0.5)'
              }}
            >
              ← Return to Command Center
            </button>
          )}
        </div>

        {/* Footer */}
        <p className="text-slate-500 text-xs text-center mt-6">
          Revenue from intelligence briefings supports continued game development and server costs.
        </p>
      </div>
    </div>
  );
}
